import { useBusiness } from '..';
import { useCallback } from 'react';
import { getBusinessFormDefaultValues } from '../util';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BusinessFormSubmitData, BusinessFormValues } from '../types';
import { useSubmitOnChange } from '../../UI';

export interface UseBusinessFormArgs {
  householdID: string;
  saveOnChange?: boolean;
  businessID?: string | null;
  defaultValuesOverrides?: Partial<BusinessFormValues>;
  handleSubmit?: (data: BusinessFormSubmitData) => void;
}

/**
 *
 * @deprecated Use useCreateBusinessForm from  packages/elements/src/UI/components/BusinessForm/hooks/useCreateBusinessForm.ts
 * or useEditBusinessForm from  packages/elements/src/UI/components/BusinessForm/hooks/useEditBusinessForm.ts
 * instead
 */
export const useBusinessForm = ({
  businessID,
  householdID,
  saveOnChange,
  defaultValuesOverrides,
  handleSubmit,
}: UseBusinessFormArgs) => {
  const { businessQuery, business } = useBusiness({ businessID, householdID });
  const formMethods = useForm<BusinessFormValues>({
    // @ts-expect-error TODO: resolve type narrowing/widening with form values to support async entity loading
    values: getBusinessFormDefaultValues(business, {
      ...defaultValuesOverrides,
    }),
  });
  const isLoadingFormData = businessQuery.isLoading;
  const formReady = !isLoadingFormData && formMethods.formState.defaultValues;

  const onSubmit: SubmitHandler<BusinessFormValues> = useCallback(
    (formValues) => {
      handleSubmit?.({ formValues, householdID, changeToken: business?.changeToken, businessID });
    },
    [handleSubmit, householdID, business?.changeToken, businessID]
  );

  useSubmitOnChange({
    onChange: onSubmit,
    watch: formMethods.watch,
    handleSubmit: formMethods.handleSubmit,
    enabled: saveOnChange && !!business,
  });

  return { formMethods, onSubmit, formReady, isLoadingFormData, business, householdID };
};
